export const PANEL_PROP = {
  BORDER_RADIUS: "borderRadius",
  TITLE: "title",
  TEXT: "text",
  ACCENT_COLOR: "accentColor",
  TEXT_COLOR: "textColor",
  DISPLAY_ELEMENTS: "displayElements",
  TYPE: "type",
  DESIGN: "design",
  ICON: "icon",
  COLOR_MUTE: "colorMute",
};

export const PANEL_SIZE = {
  SMALL: 16,
  MEDIUM: 22,
  LARGE: 28,
};

export const LIBRARY_SERVICE_ACTION = {
  create: "createPanel",
  edit: "editPanel",
};
